var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExclamationAnother = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 7,
  height: 34,
  viewBox: "0 0 7 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.30014 0.296875C4.55653 0.296875 5.57503 1.31538 5.57503 2.57177L5.57503 20.7709C5.57503 22.0273 4.55653 23.0458 3.30014 23.0458C2.04375 23.0458 1.02524 22.0273 1.02524 20.7709L1.02524 2.57177C1.02524 1.31538 2.04375 0.296875 3.30014 0.296875Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.33348 30.6288C6.33348 32.304 4.97547 33.662 3.30028 33.662C1.6251 33.662 0.26709 32.304 0.26709 30.6288C0.26709 28.9536 1.6251 27.5956 3.30028 27.5956C4.97547 27.5956 6.33348 28.9536 6.33348 30.6288Z",
  fill: "currentColor"
})));
export { SvgExclamationAnother as ReactComponent };